var _rect, _circle, _circle2, _rect2, _rect3, _circle3, _circle4, _rect4, _path, _path2, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _circle5, _circle6, _circle7, _circle8, _ellipse, _circle9, _rect16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEmptyCartBlock = function SvgEmptyCartBlock(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    transform: "translate(0.5)",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.0944,
    cy: 84.866,
    r: 6.35983,
    transform: "rotate(-13.2768 45.0944 84.866)",
    fill: "url(#paint0_linear_2044_79267)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.0944,
    cy: 84.866,
    r: 3.12128,
    transform: "rotate(-13.2768 45.0944 84.866)",
    fill: "#7AC3FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.1501,
    y: 69.041,
    width: 2.84825,
    height: 17.8016,
    rx: 1.42413,
    transform: "rotate(-22.005 37.1501 69.041)",
    fill: "#D6ECFE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.8945,
    y: 70.8027,
    width: 2.84825,
    height: 17.8016,
    rx: 1.42413,
    transform: "rotate(-22.005 25.8945 70.8027)",
    fill: "#D6ECFE"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.6022,
    cy: 78.3699,
    r: 6.35983,
    transform: "rotate(-13.2768 86.6022 78.3699)",
    fill: "url(#paint1_linear_2044_79267)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.6027,
    cy: 78.3699,
    r: 3.12128,
    transform: "rotate(-13.2768 86.6027 78.3699)",
    fill: "#7AC3FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22.5078,
    y: 21.5371,
    width: 3.12197,
    height: 16.7087,
    rx: 1.56098,
    transform: "rotate(-19.6246 22.5078 21.5371)",
    fill: "#D6ECFE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9764 36.6504C26.3696 34.9669 27.4475 33.1475 29.2155 32.8707L85.7708 24.0191C87.5194 23.7454 89.0916 25.116 89.059 26.8856L88.4066 62.3036C88.3811 63.6865 87.3658 64.8512 85.9992 65.0651L42.144 71.929C40.7954 72.1401 39.4867 71.3648 39.024 70.0807L26.9764 36.6504Z",
    fill: "url(#paint2_linear_2044_79267)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3138 38.6328C13.707 36.9493 14.7849 35.1299 16.5529 34.8532L76.4588 25.4771L75.744 64.286C75.7185 65.6689 74.7032 66.8336 73.3366 67.0475L29.4814 73.9114C28.1328 74.1225 26.8241 73.3472 26.3614 72.0631L14.3138 38.6328Z",
    fill: "url(#paint3_linear_2044_79267)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5773,
    y: 39.4316,
    width: 1.42413,
    height: 30.277,
    rx: 0.712064,
    transform: "rotate(-19.5424 24.5773 39.4316)",
    fill: "#BDE0FD"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 34.4166,
    y: 37.752,
    width: 1.42413,
    height: 30.277,
    rx: 0.712063,
    transform: "rotate(-17.0013 34.4166 37.752)",
    fill: "#BDE0FD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 45.6912,
    y: 35.7305,
    width: 1.42413,
    height: 30.277,
    rx: 0.712063,
    transform: "rotate(-8.89536 45.6912 35.7305)",
    fill: "#B3DCFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 56.5598,
    y: 34.0449,
    width: 1.42413,
    height: 30.277,
    rx: 0.712064,
    transform: "rotate(-2.55871 56.5598 34.0449)",
    fill: "#B3DCFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 67.7651,
    y: 32.3418,
    width: 1.42413,
    height: 30.277,
    rx: 0.712063,
    transform: "rotate(-0.282453 67.7651 32.3418)",
    fill: "#ABD9FE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 79.3466,
    y: 30.4863,
    width: 1.42413,
    height: 30.277,
    rx: 0.712063,
    transform: "rotate(0.995217 79.3466 30.4863)",
    fill: "#BFE2FF"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 83.7848,
    y: 29.9258,
    width: 0.953389,
    height: 30.277,
    rx: 0.476694,
    transform: "rotate(0.995217 83.7848 29.9258)",
    fill: "#C9E6FF"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 86.7469,
    y: 29.5859,
    width: 0.875648,
    height: 30.277,
    rx: 0.437824,
    transform: "rotate(0.995217 86.7469 29.5859)",
    fill: "#C9E6FF"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 32.285,
    y: 88.6094,
    width: 2.84825,
    height: 56.9651,
    rx: 1.42413,
    transform: "rotate(-98.8954 32.285 88.6094)",
    fill: "#D6ECFE"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 3.16077,
    y: 26.8594,
    width: 4.27238,
    height: 25.6343,
    rx: 2.13619,
    transform: "rotate(-98.8954 3.16077 26.8594)",
    fill: "#D6ECFE"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 9.84521,
    y: 23.5195,
    width: 3.12197,
    height: 16.7087,
    rx: 1.56098,
    transform: "rotate(-19.6246 9.84521 23.5195)",
    fill: "#D6ECFE"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.1359,
    cy: 86.7371,
    r: 6.35983,
    transform: "rotate(-13.2768 33.1359 86.7371)",
    fill: "url(#paint4_linear_2044_79267)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.1359,
    cy: 86.7371,
    r: 3.12128,
    transform: "rotate(-13.2768 33.1359 86.7371)",
    fill: "#7AC3FF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.3459,
    cy: 80.1316,
    r: 6.35983,
    transform: "rotate(-13.2768 75.3459 80.1316)",
    fill: "url(#paint5_linear_2044_79267)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.3459,
    cy: 80.1316,
    r: 3.12128,
    transform: "rotate(-13.2768 75.3459 80.1316)",
    fill: "#7AC3FF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.6,
    cx: 32.3989,
    cy: 1.0681,
    rx: 32.3989,
    ry: 1.0681,
    transform: "matrix(-1 0 0 1 92.9326 96.2969)",
    fill: "url(#paint6_linear_2044_79267)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 27.5,
    r: 14,
    fill: "#EF5350"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 25,
    width: 22,
    height: 5,
    rx: 1.33333,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2044_79267",
    x1: 42.3687,
    y1: 85.3203,
    x2: 48.3979,
    y2: 86.7692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2044_79267",
    x1: 83.8766,
    y1: 78.8242,
    x2: 89.9057,
    y2: 80.2732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2044_79267",
    x1: 70.3838,
    y1: 41.9231,
    x2: 91.0908,
    y2: 42.8978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCDFFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2044_79267",
    x1: 78.2799,
    y1: 26.3218,
    x2: 15.5922,
    y2: 13.3923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4DDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2044_79267",
    x1: 30.4103,
    y1: 87.1914,
    x2: 36.4394,
    y2: 88.6403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2044_79267",
    x1: 72.6202,
    y1: 80.5859,
    x2: 78.6494,
    y2: 82.0349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AADBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2044_79267",
    x1: 72.1612,
    y1: 0.142413,
    x2: 71.5865,
    y2: 7.93433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DD3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF8FF",
    stopOpacity: 0.3
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyCartBlock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "empty-cart-block.9bcb72919f5c21dbe02b19d2adc5570c.svg";